import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { UserRole } from '@ml/core/types/enums';
import { ConnectionService } from '@ml/core/services/connection.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./connection.service";
var UserService = /** @class */ (function () {
    function UserService(http, connectionService) {
        this.http = http;
        this.connectionService = connectionService;
        this.url = "users";
        this.user$ = new BehaviorSubject(null);
    }
    UserService.prototype.get = function () {
        var _this = this;
        if (this.user$.value) {
            return this.user$.asObservable();
        }
        if (!this.connectionService.connection &&
            localStorage.getItem('currentUser')) {
            this.user$.next(JSON.parse(localStorage.getItem('currentUser')));
            return this.user$.asObservable();
        }
        return this.http.get('user').pipe(tap(function (user) { return localStorage.setItem('currentUser', JSON.stringify(user)); }), tap(function (user) { return _this.user$.next(user); }));
    };
    UserService.prototype.changeOwnPassword = function (password) {
        var _this = this;
        return this.http
            .patch("user/change-password", {
            password: password
        })
            .pipe(tap(function () {
            _this.user$.next(tslib_1.__assign({}, _this.user$.value, { passwordChanged: new Date().toISOString() }));
        }));
    };
    UserService.prototype.changeOthersPassword = function (id, password) {
        return this.http.patch("users/" + id + "/change-password", {
            password: password
        });
    };
    UserService.prototype.setFCMToken = function (fcmToken) {
        var _this = this;
        return this.http
            .patch(this.url + "/" + this.user.id, { fcmToken: fcmToken })
            .pipe(tap(function (_user_) {
            _this.user.fcmToken = fcmToken;
            _this.user$.next(tslib_1.__assign({}, _this.user));
        }));
    };
    Object.defineProperty(UserService.prototype, "user", {
        get: function () {
            return this.user$.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "isEmployee", {
        get: function () {
            return this.user && this.user.role === UserRole.EMPLOYEE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserService.prototype, "isAdmin", {
        get: function () {
            return this.user && this.user.role === UserRole.ADMIN;
        },
        enumerable: true,
        configurable: true
    });
    UserService.prototype.removeCurrentUser = function () {
        this.user$.next(null);
        localStorage.removeItem('currentUser');
    };
    UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConnectionService)); }, token: UserService, providedIn: "root" });
    return UserService;
}());
export { UserService };
